import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { detectInitialLocale, setLocale } from './i18n/useLocale'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import { inject } from '@vercel/analytics'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { useAuthStore } from './stores/auth-store'

const app = createApp(App)

app.use(stores)
// 启动即恢复登录态 + 订阅魔法链接回跳(异步,不阻塞挂载)
useAuthStore().init()
app.use(router)
app.use(i18n)
// 初始语言:localStorage > URL 前缀 > 浏览器语言 > en(同步 <html lang>)
setLocale(detectInitialLocale())
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')

// 挂载后移除构建期预渲染注入的爬虫正文(.prerender-content 位于 #app 之外)。
// 该内容已存在于静态 HTML 供爬虫索引;SPA 接管后若不删除,用户会看到重复的无样式副本。
document.querySelectorAll('.prerender-content').forEach((el) => el.remove())

inject()
